export default __webpack_public_path__ + "static/media/suite-montanha.3b4b9ec6.webp";